export const NAME = 'name'
export const CAN_SELECT_MULTIPLE = 'can_select_multiple'
export const REQUIRED = 'required'
export const OPTIONS = 'options'
